import Evented  from './mixins/evented';
import Deferred from './mixins/deferred';
import User     from './mixins/user';
import {extend} from './mixins/mixin';

const
  _scripts        = {},
  _hasOwnProperty = Object.prototype.hasOwnProperty
;

const Application = {
  load(url, options = {}) {
    var promise, script, src, key;

    src = url;
    key = url.split('?').shift();
    if (_hasOwnProperty.call(_scripts, key)) {return _scripts[key];}

    script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    options.text && (script.text = options.text);

    promise = new window.RSVP.Promise((resolve, reject) => {
      script.onload  = () => resolve(script);
      script.onerror = reject;

      document.head.appendChild(script);
    });

    _scripts[key]  = promise;
    return promise;
  }
};

extend(Application, Evented);
extend(Application, Deferred);
extend(Application, User);

export default Application;



// WEBPACK FOOTER //
// ./src/application.js